var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.61,
    height: 19.73,
    viewBox: "0 0 21.61 19.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.37,15c-1.31,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37,2.37-1.06,2.37-2.37-1.06-2.37-2.37-2.37Zm0,3.75c-.76,0-1.38-.62-1.38-1.38s.62-1.38,1.38-1.38,1.38,.62,1.38,1.38-.62,1.38-1.38,1.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.61,15.03L15.22,1.05c-.17-.62-.74-1.05-1.38-1.05h-2.1c-.27,0-.5,.22-.5,.5s.22,.5,.5,.5h2.1c.2,0,.37,.13,.43,.34l3.84,12.21c-1.28,.4-2.26,1.45-2.55,2.77-.04,.19-.22,.33-.42,.33H6.48c-.21,0-.38-.14-.43-.34-.39-1.73-1.91-2.94-3.68-2.94-.42,0-.82,.07-1.2,.2-.26,.09-.4,.37-.31,.63,.09,.26,.37,.39,.63,.3,.27-.09,.56-.14,.87-.14,1.31,0,2.43,.89,2.72,2.16,.15,.66,.72,1.12,1.39,1.12H15.13c.66,0,1.25-.46,1.39-1.1,.22-.97,.94-1.74,1.88-2.03l.19,.61c-.99,.28-1.73,1.19-1.73,2.27,0,1.31,1.06,2.37,2.37,2.37s2.37-1.06,2.37-2.37c0-1.18-.87-2.15-1.99-2.33Zm-.38,3.71c-.76,0-1.38-.62-1.38-1.38s.62-1.38,1.38-1.38,1.38,.62,1.38,1.38-.62,1.38-1.38,1.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/Scooter.38322a64f36755fd346f229993bc1583.svg";
export { ForwardRef as ReactComponent };